module.exports = __webpack_public_path__ + "static/media/168-bulgaria.d56de8d3.svg";